import { render, staticRenderFns } from "./DialogCreateUsuarioComponent.vue?vue&type=template&id=fbc4103e&"
import script from "./DialogCreateUsuarioComponent.vue?vue&type=script&lang=js&"
export * from "./DialogCreateUsuarioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports